import React from 'react';
import styles from './ContactTypes.module.css';

const ContactTypeStatistics = ({ statistics, loading }) => {
    if (loading) {
        return (
            <div className={styles.statisticsLoading}>
                <div className={styles.spinner}></div>
                <span>Loading statistics...</span>
            </div>
        );
    }

    return (
        <div className={styles.statisticsContainer}>
            <div className={styles.statisticsHeader}>
                <h3>Contact Types Overview</h3>
                <p>Statistics about contact types in the system</p>
            </div>
            <div className={styles.statisticsGrid}>
                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Total Contact Types</h4>
                        <span className={styles.statValue}>{statistics.total}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactTypeStatistics;
